module.exports = __webpack_public_path__ + "static/media/gryphon-house-living-dining-closeup.a6e46ff8.jpeg";